import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getColorInterior } from '../thunks/vehicleThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearVehicleKey } from '../thunkKeys/commonThunksKeys';

const SLICE_NAME = 'colorInterior';

export const colorInteriorSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearColorInterior(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getColorInterior });
        builder.addCase(
            clearVehicleKey,
            () => commonInitialState,
        );
    },
});

export const { clearColorInterior } = colorInteriorSlice.actions;

export const colorInterior = colorInteriorSlice.reducer;
